import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-amber-50 font-sans text-stone-900 antialiased" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3rc9du70c5dx8" />
      <main data-id="element-2" data-mp="3rbra6pbcfxfa">
        <Hero data-id="element-3" data-mp="3rbzngibdp4r0" />
        <SocialProof data-id="element-4" data-mp="3rdkgg3i1ofmr" />
        <Testimonials data-id="element-5" data-mp="3rd189ei755lx" />
        <ProblemSection data-id="element-6" data-mp="5yj0slx59ec" />
        <SystemSection data-id="element-7" data-mp="67z9oh5w26u" />
        <ModulesSection data-id="element-8" data-mp="4n6o4eeqtbm" />
        <BonusSection data-id="element-9" data-mp="82kl3wchwbg" />
        <UrgencySection data-id="element-10" data-mp="2zl3cxocsjc6w" />
        <PricingSection data-id="element-11" data-mp="2zlv7qwykd5w4" />
        <MoreResults data-id="element-12" data-mp="2zmo3z3zwcd00" />
        <GuaranteeSection data-id="element-13" data-mp="2zn6cayzu2hoa" />
        <FAQ data-id="element-14" data-mp="33mf1rrnubte1" />
        <ClosingSection data-id="element-15" data-mp="33lwy49yumcw3" />
        <SummaryTable data-id="element-16" data-mp="33nghwajpr62m" />
        <FinalCta data-id="element-17" data-mp="33orik1hv3xpi" />
      </main>
      <Footer data-id="element-18" data-mp="38m1fe27kzbnd" />
      <PurchaseNotification data-id="element-19" data-mp="38li8dgjgy7o4" />
    </div>;
}